export default "__VITE_ASSET__zxNjN0Qh__"